import React, { useEffect, useState } from "react";
import Axios from "axios";
import { API_BASE_URL, GET_VSTORE_PROD, INSERT_ORDERS } from "../../../Config";
import Swal from "sweetalert2";
import Select from 'react-select';
import SpinLoader from "../../../feature-module/loader/SpinLoader";



const DeliveryItemAdd = () => {

  const [userDataSession, setUserDataSession] = useState([]);
  const [storeProducts, setStoreProducts] = useState([]);
  const [submitBtnLoading, setSubmitBtnLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [customersDDL, setCustomersDDL] = useState([]);
  const [selectedCus, setSelectedCus] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [vehicleInfo, setVehicleInfo] = useState('');
  const [deliveryPerson, setDeliveryPerson] = useState('');

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    const customersdata = JSON.parse(sessionStorage.getItem("filteredDDLData_Customers"));
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
      setCustomersDDL(customersdata);
    } else {
      console.log("User data not found in sessionStorage", loading);
    }
  }, []);

  useEffect(() => {
    if (!userDataSession.OrgId) return;
    setLoading(true);
    const fetchData = () => {
      const requestData = {
        OrgId: userDataSession.OrgId,
        CategoryId: 0,
        BarCode: "0",
        IsActive: 1,
        ProductId: 0,
        StoreId: 0,
        IsForSale: 1,
        UserId: userDataSession.UserId,
        Type: 0,
      };

      Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
        .then((response) => {
          setLoading(false);
          setStoreProducts(response.data.ResultData);
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error fetching data:", error);
        });
    };

    fetchData();
  }, [userDataSession.OrgId]);

  const handleCancelClick = () => {
    const productsWithAdjustStock = storeProducts.map((product) => ({
      ...product,
      AdjustStock: "",
    }));
    setStoreProducts(productsWithAdjustStock);
  };

  const handleCustomerSelect = (option) => {
    setSelectedCus(option.value);
  };
  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  // const handleProductSelect = (value) => {
  //   console.log(value, selectedProducts[0].value.value) 
  //   const alreadySelected = selectedProducts.some((prod) => prod.value === value);
  //   if (alreadySelected) {
  //     alert("Product already added to the list.");
  //   } else {
  //     setSelectedProducts([
  //       ...selectedProducts,
  //       {
  //         value,
  //         label: value.label,
  //         quantity: 1,
  //         price: storeProducts.find((p) => p.Id === value)?.AvgPrice || 0,
  //         weight: 0,
  //       }
  //     ]);
  //   }
  // };

  const handleProductSelect = (value) => {
    console.log(value.value, 'handle product click')
    // Find the product by ID in storeProducts using the selected value (id)
    const selectedProduct = storeProducts.find((prod) => prod.Id === value.value);
    console.log(selectedProduct, 'seleccted product');

    if (selectedProduct) {
        const alreadySelected = selectedProducts.some((prod) => prod.value === value.value);
        if (alreadySelected) {
            alert("Product already added to the list.");
        } else {
            setSelectedProducts([
                ...selectedProducts,
                {
                    value: selectedProduct.Id,  // Use Id as value
                    label: selectedProduct.ProductName,  // Use ProductName as label
                    quantity: 1,
                    price: selectedProduct.AvgPrice || 0,
                    weight: 0,
                }
            ]);
        }
    }
};


  const handleQuantityChange = (index, quantity) => {
    const updatedProducts = selectedProducts.map((prod, i) => 
      i === index ? { ...prod, quantity } : prod
    );
    setSelectedProducts(updatedProducts);
  };

  const handleWeightChange = (index, weight) => {
    const updatedProducts = selectedProducts.map((prod, i) => 
      i === index ? { ...prod, weight } : prod
    );
    setSelectedProducts(updatedProducts);
  };

  // const handleSubmit = (event) => {
  //   if (event) event.preventDefault();
  //   console.log(selectedProducts, "selected products");

  //   const requestPayload = {
  //     orgid: userDataSession.OrgId,
  //     userid: userDataSession.UserId,
  //     OrgType: 0,
  //     BillNo: null,
  //     Order: {
  //       StoreId: userDataSession.StoreId,
  //       PosId: 0,
  //       OrderType: 9,
  //       Total: 0,
  //       Discounts: 0,
  //       SGST: 9,
  //       CGST: 9,
  //       IGST: 18,
  //       Status: 1,
  //       IsActive: 1,
  //       Orderdate: selectedDate,
  //       DiscountId: 0,
  //       DiningId: 0,
  //       ReturnFromOrdId: 0,
  //       CustomerId: selectedCus || 0,
  //       PriceListId: 0,
  //       TransportMode: deliveryPerson,
  //       TransportvehicleNumber: vehicleInfo,
  //       AdditionalCharges: 0,
  //       AdditionalRoundOffAmount: 0,
  //       IsAcknowledge: 0,
  //       TransportAmount: 0,
  //       InvoiceNo: "NULL",
  //       EmpId: userDataSession.UserId,
  //     },
  //     OrderDetails: selectedProducts.map((prod) => ({
  //       ProductId: prod.value,
  //       Quantity: prod.quantity,
  //       UnitPrice: prod.price,
  //       Discount: 0,
  //       SGSTS: 18,
  //       CGSTS: 18,
  //       IGSTS: 0,
  //       Total: prod.price * prod.quantity,
  //       Status: 1,
  //       RefundQuantity: 0,
  //       IsActive: 1,
  //       VendorId: 0,
  //       IsComplement: 0,
  //       CGSTrate: 9,
  //       SGSTrate: 9,
  //       IGSTrate: 0,
  //       NoOfBags: 0,
  //       Comments: "NULL",
  //       ItemWeight: prod.weight,
  //       ItemPackingWeight: 0,
  //       BilledBarCode: "NULL",
  //     })),
  //     OrderAdditionalDetails: selectedProducts.map((prod) => ({
  //       ProductId: prod.value,
  //       MakingCharges: null,
  //       OtherCharges: null,
  //       MetalRateId: null,
  //     })),
  //     OrderPayments: [
  //       {
  //         PaymentTypeId: null,
  //         PaidAmount: null,
  //         CardNo: "NULL",
  //         MobileNo: "NULL",
  //       },
  //     ],
  //     StockHistory: selectedProducts.map((prod) => ({
  //       ProductId: prod.value,
  //       StoreId: userDataSession.StoreId,
  //       StockEffectTypeId: 0,
  //       StockAdjusted: prod.quantity,
  //       TransactionId: 0,
  //       TransfarStockId: 0,
  //       StockAdjustId: 0,
  //       IsActive: 1,
  //       SupplierId: 0,
  //     })),
  //     StoreProducts: selectedProducts.map((prod) => ({
  //       ProductId: prod.value,
  //       StoreId: userDataSession.StoreId,
  //       StockAdjusted: -prod.quantity,
  //     })),
  //   };

  //   console.log(requestPayload, "data sending to service...");

  //   setSubmitBtnLoading(true);

  //   Axios.post(`${API_BASE_URL}${INSERT_ORDERS}`, requestPayload)
  //     .then((response) => {
  //       const data = response.data;
  //       console.log(data, "reponse data getting from api");
  //       setSubmitBtnLoading(false);
  //       if (data[0].OrderId >= 1) {
  //         Swal.fire({
  //           title: "Success",
  //           text: "Order added successfully.",
  //           icon: "success",
  //         }).then((result) => {
  //           if (result.isConfirmed || result.isDismissed) {
  //             window.location.reload();
  //           }
  //         });
  //       } else {
  //         Swal.fire({
  //           title: "Error",
  //           text: "Failed to added order.",
  //           icon: "error",
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       setSubmitBtnLoading(false);
  //       Swal.fire({
  //         title: "Error",
  //         text: "An error occurred while adding the order.",
  //         icon: "error",
  //       });
  //       console.error("Error:", error);
  //     });
  // };

  const handleSubmit = (event) => {
    if (event) event.preventDefault();
    console.log(selectedProducts, "selected products");
  
    const orderDetails = selectedProducts.map((prod) => {
      const total = prod.quantity * prod.price;
      return {
        ProductId: prod.value,
        Quantity: prod.quantity,
        UnitPrice: prod.price,
        Discount: 0,
        SGST: 18,
        CGST: 18,
        IGST: 0,
        Total: total,
        Status: 1,
        RefundQuantity: 0,
        IsActive: 1,
        VendorId: 0,
        IsComplement: 0,
        CGSTrate: 9,
        SGSTrate: 9,
        IGSTrate: 0,
        NoOfBags: 0,
        Comments: "NULL",
        ItemWeight: prod.weight,
        ItemPackingWeight: 0,
        BilledBarCode: "NULL",
      };
    });
  
    // Calculate the total order amount
    const totalOrderAmount = orderDetails.reduce((acc, prod) => acc + prod.Total, 0);
  
    // Construct request payload
    const requestPayload = {
      orgid: userDataSession.OrgId,
      userid: userDataSession.UserId,
      OrgType: 0,
      BillNo: null,
      Order: {
        StoreId: userDataSession.StoreId,
        PosId: 0,
        OrderType: 9,
        Total: totalOrderAmount,
        Discount: 0,
        SGST: 9,
        CGST: 9,
        IGST: 18,
        Status: 1,
        IsActive: 1,
        Orderdate: selectedDate,
        DiscountId: 0,
        DiningId: 0,
        ReturnFromOrdId: 0,
        CustomerId: selectedCus || 0,
        PriceListId: 0,
        TransportMode: deliveryPerson,
        TransportvehicleNumber: vehicleInfo,
        AdditionalCharges: 0,
        AdditionalRoundOffAmount: 0,
        IsAcknowledge: 0,
        TransportAmount: 0,
        InvoiceNo: "NULL",
        EmpId: userDataSession.UserId,
      },
      OrderDetails: orderDetails,
      OrderAdditionalDetails: selectedProducts.map((prod) => ({
        ProductId: prod.value,
        MakingCharges: null,
        OtherCharges: null,
        MetalRateId: null,
      })),
      OrderPayments: [
        {
          PaymentTypeId: null,
          PaidAmount: null,
          CardNo: "NULL",
          MobileNo: "NULL",
        },
      ],
      StockHistory: selectedProducts.map((prod) => ({
        ProductId: prod.value,
        StoreId: userDataSession.StoreId,
        StockEffectTypeId: 0,
        StockAdjusted: prod.quantity,
        TransactionId: 0,
        TransfarStockId: 0,
        StockAdjustId: 0,
        IsActive: 1,
        SupplierId: 0,
      })),
      StoreProducts: selectedProducts.map((prod) => ({
        ProductId: prod.value,
        StoreId: userDataSession.StoreId,
        StockAdjusted: -prod.quantity,
      })),
    };
  
    console.log(requestPayload, "data sending to service...");
  
    setSubmitBtnLoading(true);
  
    Axios.post(`${API_BASE_URL}${INSERT_ORDERS}`, requestPayload)
      .then((response) => {
        const data = response.data;
        console.log(data, "response data from API");
        setSubmitBtnLoading(false);
        if (data[0].OrderId >= 1) {
          Swal.fire({
            title: "Success",
            text: "Order added successfully.",
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
              window.location.reload();
            }
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "Failed to add order.",
            icon: "error",
          });
        }
      })
      .catch((error) => {
        setSubmitBtnLoading(false);
        Swal.fire({
          title: "Error",
          text: "An error occurred while adding the order.",
          icon: "error",
        });
        console.error("Error:", error);
      });
  };
  

  const handleRemoveProduct = (index) => {
    const updatedProducts = selectedProducts.filter((_, i) => i !== index);
    setSelectedProducts(updatedProducts);
  };

  return (
    <div>
      {/* Add Adjustment */}
      {submitBtnLoading&&(<SpinLoader/>)}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightDeliveryAdd"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "40%", maxWidth: '40%' }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Create Delivery Challan</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={handleCancelClick}
          />
        </div>{" "}
        <hr />
        <div className="offcanvas-body">
          <form onSubmit={handleSubmit}>
            <div className="row">
                <div className="col-6">
                  <label>Customer</label>
                  <Select
                    options={customersDDL?.map((prod) => ({
                      value: prod.ItemId,
                      label: prod.ItemValue,
                    }))}
                    className="select"
                    placeholder="Select an customer"
                    onChange={handleCustomerSelect}
                  />
                </div>
                <div className="col-6">
                    <label>Date</label>
                    <input 
                        className="form-control"
                        type="date"
                        value={selectedDate}
                        onChange={handleDateChange}
                    />
                </div>
                <div className="col-6 mt-2">
                    <label>Vehicle No</label>
                    <input 
                        className="form-control"
                        type="text"
                        placeholder="Enter vehicle no"
                        onChange={(e) => setVehicleInfo(e.target.value)}
                    />
                </div>
                <div className="col-6 mt-2">
                    <label>Delivery person</label>
                    <input 
                        className="form-control"
                        type="text"
                        placeholder="Delivery person name"
                        onChange={(e) => setDeliveryPerson(e.target.value)}
                    />
                </div>
                <div className="col-6 my-2">
                  <label>Product</label>
                  <Select
                      className="select"
                      options={storeProducts.map((prod) => ({
                        value: prod.Id,
                        label: prod.ProductName,
                      }))}
                      placeholder="Choose product"
                      onChange={handleProductSelect}
                  />
                </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="modal-body-table">
                  <div className="table-responsive">
                    <table className="table  datanew">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Item</th>
                          <th>Weight</th>
                          <th>Quantity</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedProducts?.map((item, index) => (
                          <tr key={index}>
                            <th>{index + 1}</th>
                            <td>{item.label}</td>
                            <td>
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Weight"
                                value={item.weight}
                                onChange={(e) => handleWeightChange(index, e.target.value)}
                                onWheel={(e) => e.target.blur()}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Qty"
                                value={item.quantity}
                                onChange={(e) => handleQuantityChange(index, e.target.value)}
                                onWheel={(e) => e.target.blur()}
                              />
                            </td>
                            <td>
                              <button
                                className="btn border"
                                type="button"
                                onClick={() => handleRemoveProduct(index)}
                              >
                                <i className="fa-regular fa-trash-can text-danger"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                  <div className="col-12">
                    <label>Notes</label>
                    <textarea className="form-control"
                        placeholder="Enter notes..."
                    ></textarea>
                  </div>
              </div>
            </div>
            <div className="modal-footer-btn">
              <button
                type="button"
                className="btn btn-cancel me-2"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                onClick={handleCancelClick}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-submit">
                {submitBtnLoading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DeliveryItemAdd;
